import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo, useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SlideNavigation } from "shared/components/slideNavigation";
import useQueryState from "shared/hooks/useQueryState";
import { DropdownTabs } from "shared/pages/exploreHseContextsNew/components/DropdownTabs";
import { useTheme } from "styled-components";

const initialTab = 'all_projects';

export const CompetitionModalTabs: FC = () => {
    const isMobile = useIsMobile();
    const theme = useTheme();
    const isS = useBreakpoint(LayoutConst.screen.s-1);
    const { t } = useTranslation();
    const [time, setTime] = useState(Date.now());
    
    const [{ tab: currentTab = initialTab }, setQueryParams] = useQueryState();

    const activeTab = useMemo(() => currentTab, [currentTab]);

    const navItems = useMemo(() => (
        {
            all_projects: t(`tab_names.competition_tabs.all_projects`),
            selected_projects: t(`tab_names.competition_tabs.selected_projects`),
        }
        
      ), [t])

      const onTabChange = useCallback((tab: string) => {
        setQueryParams({ page: 1, tab, sorting: undefined }, { replace: true });
        setTime(Date.now())
      }, [setQueryParams])

      useEffect(() => {
        return () => {
          setQueryParams({ tab: undefined  }, { replace: true });
        }
      }, [])

    return useMemo(() => {
        return (
          <FlexBox offsetTopMobile={isS ? 8 : 0}>
            {!isMobile ? (
              <SlideNavigation
                activeIndexKey={activeTab}
                onChange={onTabChange}
                items={navItems}
                isDropdown
                autoWidth
                isLoading={false}
                whiteTheme={false}
                isCompetition={true}
              /> 
            ) : (
             <>
                <DropdownTabs
                  customTitleTheme={theme as any}
                  whiteTheme={false}
                  activeTabKey={activeTab}
                  isShort={true}
                  items={navItems}
                  onChange={onTabChange}
                />
             </>
            )}
          </FlexBox>
        )
      }, [activeTab, isS, navItems, theme, time, isMobile, onTabChange ])
}import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo, useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SlideNavigation } from "shared/components/slideNavigation";
import useQueryState from "shared/hooks/useQueryState";
import { DropdownTabs } from "shared/pages/exploreHseContextsNew/components/DropdownTabs";
import { useTheme } from "styled-components";

const initialTab = 'all_projects';

export const CompetitionModalTabs: FC = () => {
    const isMobile = useIsMobile();
    const theme = useTheme();
    const isS = useBreakpoint(LayoutConst.screen.s-1);
    const { t } = useTranslation();
    const [time, setTime] = useState(Date.now());
    
    const [{ tab: currentTab = initialTab }, setQueryParams] = useQueryState();

    const activeTab = useMemo(() => currentTab, [currentTab]);

    const navItems = useMemo(() => (
        {
            all_projects: t(`tab_names.competition_tabs.all_projects`),
            selected_projects: t(`tab_names.competition_tabs.selected_projects`),
        }
        
      ), [t])

      const onTabChange = useCallback((tab: string) => {
        setQueryParams({ page: 1, tab, sorting: undefined }, { replace: true });
        setTime(Date.now())
      }, [setQueryParams])

      useEffect(() => {
        return () => {
          setQueryParams({ tab: undefined  }, { replace: true });
        }
      }, [])

    return useMemo(() => {
        return (
          <FlexBox offsetTopMobile={isS ? 8 : 0}>
            {!isMobile ? (
              <SlideNavigation
                activeIndexKey={activeTab}
                onChange={onTabChange}
                items={navItems}
                isDropdown
                autoWidth
                isLoading={false}
                whiteTheme={false}
                isCompetition={true}
              /> 
            ) : (
             <>
                <DropdownTabs
                  customTitleTheme={theme as any}
                  whiteTheme={false}
                  activeTabKey={activeTab}
                  isShort={true}
                  items={navItems}
                  onChange={onTabChange}
                />
             </>
            )}
          </FlexBox>
        )
      }, [activeTab, isS, navItems, theme, time, isMobile, onTabChange ])
}